import React, {Fragment, useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import {Modal, ModalBody, ModalHeader, Badge, Spinner} from "reactstrap";
import {setAnalyticsDialog} from "../store/financesSummarySlice";
import axios from "axios";


function AiAnalysis(props) {
    const dispatch = useDispatch();
    const [analysis, setAnalysis] = useState();

    const { size = "xl", financesSummaryState,filters } = props;
    console.log(filters)
    const getSeverityColor = (severity) => {
        switch ((severity || "").toLowerCase()) {
            case "high":
                return "danger";
            case "medium":
                return "warning";
            case "low":
                return "success";
            default:
                return "secondary";
        }
    };
    const buildPaymentSources = (paymentsSource) => {

        const total = paymentsSource.reduce(
            (sum, item) => sum + Number(item.total_amount || 0),
            0
        );

        return paymentsSource
            .filter(item => item.total_amount > 0)
            .map(item => ({
                source: item.name,
                amount: Number(item.total_amount),
                share_pct: total
                    ? Number(((item.total_amount / total) * 100).toFixed(2))
                    : 0
            }));
    };
    const sendData = async () => {
        try {
            const finance_data=financesSummaryState.data
            console.log(finance_data.total_sales)

            const response = await axios.post(
                "https://ai-apps.mygoddiva.com/finance/analytics",
                {
                    date_range: {
                        start_date: filters?.start_date,
                        end_date: filters?.end_date,
                        granularity: "monthly"
                    },
                    sales: {
                        gross_sales: Number(finance_data.gross_sales || 0),
                        discounts: Number(finance_data.discount || 0),
                        returns: Number(finance_data.total_return || 0),
                        net_sales: Number(finance_data.net_sales || 0),
                        shipping_income: Number(finance_data.shipping_charges || 0),
                        taxes: Number(finance_data.total_tax || 0)
                    },
                    gross_profit_breakdown: {
                        cogs: Number(finance_data.total_mp_cost || 0),
                        commissions: Number(finance_data.commission_amount || 0),
                        gateway_fees: Number(finance_data.gateway_fee || 0),
                        shipping_costs: Number(finance_data.shipping_rate || 0),
                        gross_profit: Number(finance_data.gross_profit || 0)
                    },
                    payment_sources: buildPaymentSources(finance_data.paymentsSource || [])
                }
            );
             setAnalysis(response.data);
            console.log(response.data);

        } catch (error) {
            console.error(error);
        }
    };

    const closeModalDialog = () => {
        dispatch(setAnalyticsDialog({props: {
                isOpen: false
            }}));
    };
    useEffect(() => {
        if(financesSummaryState.analyticDialogProps.props.isOpen){
            sendData()
        }

    },[financesSummaryState.analyticDialogProps])

    return (
        <Fragment>
            <div className="form-row mb-3">
        <Modal
            size={size}
            {...financesSummaryState.analyticDialogProps.props}
            toggle={closeModalDialog}
        >
            <ModalHeader toggle={closeModalDialog}>
                <strong>Finance AI Analyst</strong>
            </ModalHeader>

            <ModalBody>
                {analysis ?<div className="finance-analysis-wrapper">
                    {/* Executive Summary */}
                    <section className="mb-4">
                        <h5 className="mb-3 border-bottom pb-2">
                            Executive Summary
                        </h5>
                        <p className="mb-0">{analysis.page_summary}</p>
                    </section>

                    <div className="row">
                        {/* KPI INSIGHTS */}
                        <div className="col-md-6 mb-4">
                            <h6 className="mb-3 text-uppercase fw-bold">
                                KPI Insights
                            </h6>
                            <div className="bg-dark p-3 rounded">
                                {analysis.kpi_insights?.length > 0 ? (
                                    <ul className="mb-0 ps-3">
                                        {analysis.kpi_insights.map((item, index) => (
                                            <li key={index} className="mb-2">
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="mb-0">No KPI insights available.</p>
                                )}
                            </div>
                        </div>

                        {/* ANOMALIES */}
                        <div className="col-md-6 mb-4">
                            <h6 className="mb-3 text-uppercase fw-bold">
                                Anomalies Detected
                            </h6>

                            {analysis.anomalies?.length > 0 ? (
                                analysis.anomalies.map((item, index) => (
                                    <div
                                        key={index}
                                        className="border rounded p-3 mb-3 shadow-sm"
                                    >
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <strong>{item.metric}</strong>
                                            <Badge color={getSeverityColor(item.severity)}>
                                                {item.severity?.toUpperCase()}
                                            </Badge>
                                        </div>

                                        <p className="mb-2">
                                            <strong>Issue:</strong> {item.issue}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Impact:</strong> {item.impact}
                                        </p>
                                        <p className="mb-0 text-muted">
                                            <strong>Possible Reason:</strong>{" "}
                                            {item.possible_reason}
                                        </p>
                                    </div>
                                ))
                            ) : (
                                <p>No anomalies detected.</p>
                            )}
                        </div>
                    </div>

                    {/* Margin Driver Analysis */}
                    <section className="mb-4">
                        <h6 className="mb-3 text-uppercase fw-bold">
                            Margin Driver Analysis
                        </h6>
                        <div className="row">
                            {analysis.margin_driver_analysis?.map((item, index) => (
                                <div className="col-md-6 mb-3" key={index}>
                                    <div className="border rounded p-3 h-100">
                                        <div className="d-flex justify-content-between mb-2">
                                            <strong>{item.driver}</strong>
                                            <Badge
                                                color={
                                                    item.effect === "positive"
                                                        ? "success"
                                                        : "danger"
                                                }
                                            >
                                                {item.effect}
                                            </Badge>
                                        </div>
                                        <p className="mb-2">{item.details}</p>
                                        <small className="text-muted">
                                            {item.estimated_contribution}
                                        </small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Channel Partner Insights */}
                    <section className="mb-4">
                        <h6 className="mb-3 text-uppercase fw-bold">
                            Channel Partner Insights
                        </h6>
                        <div className="bg-dark p-3 rounded">
                            <ul className="mb-0 ps-3">
                                {analysis.channel_partner_insights?.map((item, index) => (
                                    <li key={index} className="mb-2">
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </section>

                    {/* Reconciliation Insights */}
                    <section className="mb-4">
                        <h6 className="mb-3 text-uppercase fw-bold">
                            Reconciliation Insights
                        </h6>
                        {analysis.reconciliation_insights?.map((item, index) => (
                            <div key={index} className="border rounded p-3 mb-3">
                                <h6 className="mb-2">{item.area}</h6>
                                <p className="mb-2">
                                    <strong>Finding:</strong> {item.finding}
                                </p>
                                <p className="mb-2">
                                    <strong>Possible Reason:</strong>{" "}
                                    {item.possible_reason}
                                </p>
                                <p className="mb-0">
                                    <strong>Action:</strong> {item.action}
                                </p>
                            </div>
                        ))}
                    </section>

                    {/* Dashboard Suggestions */}
                    <section className="mb-4">
                        <h6 className="mb-3 text-uppercase fw-bold">
                            AI Suggestions For Dashboard
                        </h6>
                        <div className="bg-dark p-3 rounded">
                            <ul className="mb-0 ps-3">
                                {analysis.ai_suggestions_for_dashboard?.map(
                                    (item, index) => (
                                        <li key={index} className="mb-2">
                                            {item}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                    </section>

                    {/* Priority Actions */}
                    <section className="mb-3">
                        <h6 className="mb-3 text-uppercase fw-bold">Priority Actions</h6>

                        <div className="d-flex gap-3 flex-wrap">
                            {analysis.priority_actions?.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        flex: "1 1 30%",
                                        background: "#2f3344",
                                        color: "#fff",
                                        padding: "16px",
                                        borderRadius: "6px",
                                        minHeight: "80px"
                                    }}
                                >
                                    <strong>{index + 1}.</strong> {item}
                                </div>
                            ))}
                        </div>
                    </section>
                </div>:<div>     <div className="text-center py-4">
                    <Spinner />
                    <p className="mt-2 mb-0">Loading analysis...</p>
                </div></div>}
            </ModalBody>
        </Modal>
            </div>
        </Fragment>
    );
}

export default AiAnalysis;